/**
 * strate-focus-produit
 * 聚焦产品组件：点击产品缩略图切换标题 / 主图 / 链接（产品级）
 * 注册为 <ml-focus-produit>，与主题 ml-* 自定义组件体系保持一致
 */
class MlFocusProduit extends HTMLElement {
  constructor() {
    super();

    this.variantsEl = this.querySelector("[data-focus-produit-variants]");
    this.imageEl = this.querySelector("[data-focus-produit-image]");
    this.titleEl = this.querySelector("[data-focus-produit-title]");
    this.links = this.querySelectorAll("[data-focus-produit-link]");
    this.dataEl = this.querySelector("[data-focus-produit-data]");
    this.dataMap = new Map();

    if (this.dataEl) {
      this.dataEl.querySelectorAll("[data-product-id]").forEach((row) => {
        this.dataMap.set(row.dataset.productId, row.dataset);
      });
    }

    if (this.variantsEl) {
      this.variantsEl.addEventListener("click", (event) => {
        this.handleVariantClick(event);
      });
    }
  }

  handleVariantClick(event) {
    const button = event.target.closest("[data-focus-produit-variant]");
    if (!button) return;

    const productData = this.dataMap.get(button.dataset.productId);
    if (!productData) return;

    // 切换缩略图激活态
    this.variantsEl
      .querySelectorAll("[data-focus-produit-variant]")
      .forEach((item) => {
        item.classList.remove("is-active");
        item.removeAttribute("aria-current");
      });
    button.classList.add("is-active");
    button.setAttribute("aria-current", "true");

    // 更新标题
    if (this.titleEl && productData.title) {
      this.titleEl.textContent = productData.title;
    }

    // 更新所有指向产品页的链接
    if (productData.url) {
      this.links.forEach((link) => link.setAttribute("href", productData.url));
    }

    // 更新主产品图（src 与 srcset 一起切换，避免浏览器沿用旧 srcset）
    if (this.imageEl && productData.image) {
      this.imageEl.setAttribute("src", productData.image);
      if (productData.imageSrcset) {
        this.imageEl.setAttribute("srcset", productData.imageSrcset);
      } else {
        this.imageEl.removeAttribute("srcset");
      }
      if (productData.title) {
        this.imageEl.setAttribute("alt", productData.title);
      }
    }
  }
}

customElements.define("ml-focus-produit", MlFocusProduit);
